import { config } from '@iheartjane/config';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import qs from 'qs';

import { api } from '@jane/shared/data-access';

interface RemoveUserFromCartProps {
  uuid: string;
}

const removeUserFromCart = async ({ uuid }: RemoveUserFromCartProps) => {
  const queryParams = qs.stringify({ uuid, user_id: null });
  return await api.patch(`${config.apiPath}/carts?${queryParams}`, undefined);
};

export const useRemoveUserFromCart = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: removeUserFromCart,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['cart'] });
    },
  });
};
